// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ce","heading":"De","items":"Ee","featureCss":"Fe","disabled":"Ge","imgCss":"He"};